import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Screenshots from './Screenshots';
import FAQ from './FAQ';
import Download from './Download';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <Screenshots />
      <FAQ />
      <Download />
      <Footer />
    </>
  );
};

export default Home;
